import { atom } from 'recoil';

export const userInfoState = atom({
  key: 'userInfoState',
  default: {
    userId: '',
    userName: '',
    maskingUserName: '',
    siteNumber: '',
    subsidiaryCompanyCode: '',
    loginType: '',
    memberNumber: '',
    adultCertificationDate: '',
    login: false,
    empNumber: '',
    otpUseYn: false,
  },
});

export const recentlyViewedGoodListState = atom({
  key: 'recentlyViewedGoodListState',
  default: null,
});
